import { render } from "./DocumentUploader.vue?vue&type=template&id=7053e76c&scoped=true"
import script from "./DocumentUploader.vue?vue&type=script&lang=js"
export * from "./DocumentUploader.vue?vue&type=script&lang=js"

import "./DocumentUploader.vue?vue&type=style&index=0&id=7053e76c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7053e76c"]])

export default __exports__